// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3tdxD","approved":"Status_approved__3NT44","rejected":"Status_rejected__1arCf","expired":"Status_expired__aa2Kh","label":"Status_label__Tr-v_"};